module.exports = __webpack_public_path__ + "img/im_chat_bg.02053f36.png";